/**
 * @file components/audit-tasks/phases/PhaseLab.tsx
 * @description 階段 4：檢驗 / 資材。完全內聯，無外鏈。
 * 頂部「檢驗需求」卡片可標記本案無需檢驗（視為已跳過）；
 * 資材審查只在 TOP（有機）方案下顯示。
 */

import { Space } from 'antd';
import type { AuditTaskDetail } from '@zhcb/shared';
import { LabWaiverCard } from '@/components/audit-tasks/lab/LabWaiverCard';
import { LabReportsInlineCard } from '@/components/audit-tasks/lab/LabReportsInlineCard';
import { OrganicMaterialReviewsCard } from '@/components/audit-tasks/lab/OrganicMaterialReviewsCard';

interface Props {
  task: AuditTaskDetail;
}

export function PhaseLab({ task }: Props) {
  // verification_scheme enum 真實值：'TOP' (有機農產品) / 'TAP' (產銷履歷) / 'ECO'
  // 只在 TOP 下顯示資材審查（caseScheme 可能為 null，=== 比較天然安全）
  const isOrganic = task.caseScheme === 'TOP';

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <LabWaiverCard task={task} />
      <LabReportsInlineCard caseId={task.caseId} />
      {isOrganic && <OrganicMaterialReviewsCard caseId={task.caseId} />}
    </Space>
  );
}
